import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/plan/view/license.plan.seatHolders.query.gql"
import type {
  LicensePlanSeatHoldersQuery,
  LicensePlanSeatHoldersQueryVariables,
} from "@/v2-backoffice-client/license/plan/view/__types__/license.plan.seatHolders.query"

type Options = QueryHookOptions<
  LicensePlanSeatHoldersQuery,
  LicensePlanSeatHoldersQueryVariables
>

export function useLicensePlanSeatHoldersQuery(options?: Options) {
  return useQuery<
    LicensePlanSeatHoldersQuery,
    LicensePlanSeatHoldersQueryVariables
  >(query, options)
}
